{
  "Automatic ({language})": "Automatycznie ({language})",
  "Language": "Język",
  "Cancel": "Anuluj",
  "OK": "OK",
  "Ok": "OK",
  "Okay": "OK",
  "Yes": "Tak",
  "No": "Nie",
  "Save": "Zapisz",
  "Saved": "Zapisano",
  "Saving...": "Zapisywanie...",
  "Saving…": "Zapisywanie…",
  "Delete": "Usuń",
  "Remove": "Usuń",
  "Edit": "Edytuj",
  "Change": "Zmień",
  "Close": "Zamknij",
  "Done": "Gotowe",
  "Back": "Wstecz",
  "Next": "Dalej",
  "Continue": "Dalej",
  "Skip": "Pomiń",
  "Retry": "Ponów",
  "Try again": "Spróbuj ponownie",
  "Please try again.": "Spróbuj ponownie.",
  "Please try again": "Spróbuj ponownie",
  "Something went wrong": "Coś poszło nie tak",
  "Something went wrong. Please try again.": "Coś poszło nie tak. Spróbuj ponownie.",
  "Error": "Błąd",
  "Loading...": "Wczytywanie...",
  "Loading…": "Wczytywanie…",
  "Share": "Udostępnij",
  "Copy": "Kopiuj",
  "Copy link": "Kopiuj link",
  "Copied": "Skopiowano",
  "Copied!": "Skopiowano!",
  "Link copied": "Skopiowano link",
  "Open": "Otwórz",
  "Restore": "Przywróć",
  "Learn more": "Więcej informacji",
  "More": "Więcej",
  "Help": "Pomoc",
  "Settings": "Ustawienia",
  "Open Settings": "Otwórz Ustawienia",
  "Profile": "Profil",
  "Email": "E-mail",
  "Password": "Hasło",
  "Name": "Nazwa",
  "Title": "Tytuł",
  "Location": "Miejsce",
  "Date and time": "Data i godzina",
  "Privacy": "Prywatność",
  "Embed": "Embed",
  "Branding": "Branding",
  "Logo": "Logo",
  "Guestbook": "Księga gości",
  "Fundraising": "Zbiórka",
  "Pricing": "Ceny",
  "Plans": "Plany",
  "EventLive Plans": "Plany EventLive",
  "My Events": "Moje wydarzenia",
  "Event link": "Link do wydarzenia",
  "Event title": "Tytuł wydarzenia",
  "Go Live": "Rozpocznij transmisję",
  "Watch Live": "Oglądaj na żywo",
  "Live only": "Tylko na żywo",
  "Start free test": "Rozpocznij darmowy test",
  "Free test": "Darmowy test",
  "Unlock event": "Odblokuj wydarzenie",
  "Unlock": "Odblokuj",
  "Sell Tickets": "Sprzedawaj bilety",
  "Video Wall": "Ściana wideo",
  "Manage Video": "Zarządzaj wideo",
  "Upload video": "Prześlij wideo",
  "What's new": "Co nowego",
  "What's New": "Co nowego",
  "Camera": "Kamera",
  "Required": "Wymagane",
  "Terms": "Regulamin",
  "Monthly": "Miesięcznie",
  "Unlimited": "Bez limitu",
  "Not found": "Nie znaleziono",
  "Not signed in": "Nie zalogowano",
  "Please sign in again.": "Zaloguj się ponownie.",
  "Too many requests. Please wait a moment and try again.": "Zbyt wiele żądań. Poczekaj chwilę i spróbuj ponownie.",
  "Welcome to EventLive": "Witamy w EventLive",
  "Today": "Dzisiaj",
  "Tomorrow": "Jutro",
  "Yesterday": "Wczoraj",
  "MMM D, YYYY": "D MMM YYYY",
  "MMM D": "D MMM",
  "h:mm A": "HH:mm",
  "h:mm a": "HH:mm",
  "Test Event": "Wydarzenie testowe"
}
